import { Router } from './router.js';

export function App(): JSX.Element {
  return <Router />;
}
